export const mainScript =
  "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/codemirror.min.js";

export const extraScrpts = [
  "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/addon/edit/matchbrackets.min.js",
  "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/clike/clike.min.js",
  "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/shell/shell.min.js",
  "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/javascript/javascript.min.js",
];

export const modeScripts = {
  CSS:
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/css/css.min.js",
  Dart:
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/dart/dart.min.js",
  Elm:
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/elm/elm.min.js",
  Go: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/go/go.min.js",
  Groovy:
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/groovy/groovy.min.js",
  HTML:
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/htmlmixed/htmlmixed.min.js",
  HTTP:
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/http/http.min.js",
  JSX:
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/jsx/jsx.min.js",
  LaTeX:
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/stex/stex.min.js",
  Lua:
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/lua/lua.min.js",
  Markdown:
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/markdown/markdown.min.js",
  Nginx:
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/nginx/nginx.min.js",
  Perl:
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/perl/perl.min.js",
  PHP:
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/php/php.min.js",
  PowerShell:
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/powershell/powershell.min.js",
  Python:
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/python/python.min.js",
  R: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/r/r.min.js",
  Ruby:
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/ruby/ruby.min.js",
  Sass:
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/sass/sass.min.js",
  SQL:
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/sql/sql.min.js",
  Swift:
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/swift/swift.min.js",
  XML:
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/xml/xml.min.js",
  YAML:
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/yaml/yaml.min.js",
};
